import {Divider} from '@mui/material';
import FrontdeskButton from '~/components/FrontdeskButton';
import CustomTable from '~/components/CustomTable';
import BackButton from '../../common/components/BackButton';

import {GenericFinancialRecordProps} from './types';
import NewPaymentIcon from '$assets/svgs/new-payment.svg?react';
import SubmitClaimIcon from '$assets/svgs/new-payment.svg?react';
import './styles.scss';

function GenericFinancialRecordComponent(
  props: GenericFinancialRecordProps
): JSX.Element {
  const {
    data,
    patient,
    isLoading,
    recordType,
    tableColumns,
    transformData,
    onActionButtonClick,
    onRowClick,
    currentPage = 0,
    pageSize = 10,
    totalCount = 0,
    onPageChange,
  } = props;

  const getButtonConfig = () => {
    if (recordType === 'insurance-claim') {
      return {
        title: 'Submit a claim',
        icon: <SubmitClaimIcon />,
      };
    }
    return {
      title: 'New payment',
      icon: <NewPaymentIcon />,
    };
  };

  const buttonConfig = getButtonConfig();

  return (
    <div className="financial-record-container flex flex-col flex-1 pt-0 px-10 pb-10">
      <div className="flex justify-start mb-2">
        <BackButton className="mt-4" />
      </div>
      <Divider className="custom-divider !mt-0" />
      <div className="flex justify-between items-center">
        <div className="header-title ml-4">
          {patient?.full_name} - Financial record
        </div>
        <div className="mr-4">
          <FrontdeskButton
            title={buttonConfig.title}
            startIcon={buttonConfig.icon}
            onClick={onActionButtonClick}
          />
        </div>
      </div>
      <Divider />
      <div className="table-wrapper">
        <div className="table-content">
          <CustomTable
            showPagination={true}
            columns={tableColumns}
            data={transformData(data)}
            loading={isLoading}
            currentPage={currentPage}
            pageSize={pageSize}
            totalCount={totalCount}
            onPageChange={onPageChange}
            onRowClick={onRowClick}
          />
        </div>
      </div>
    </div>
  );
}

export default GenericFinancialRecordComponent;
